export default "__VITE_PUBLIC_ASSET__3fe1415d__"